export default "__VITE_PUBLIC_ASSET__1156ecf2__"